enum SectionEnum {
    ABOUT = "about",
    EXPERIENCE = "experience",
    SKILLS = "skills",
}

export default SectionEnum;
